<template>
    <empty-settings 
        model="la Dashboard"
    ></empty-settings>
</template>

<script>
    import EmptySettings from '@/components/common/EmptySettings'

    export default {
        name: 'dashboard-options',
        components: {
            EmptySettings
        },
        props: {},
        data() {
            return {

            }
        },

        created() {
            this.$store.commit('endProgress')
        },
    }
</script>

<style scoped>

</style>